import { ReactComponent as WaveIcon } from 'features/CartAbandonmentFlow/wave.svg'
import { formatNumberAsThousands } from 'utils/priceHelpers'

import styles from './DripTriggerCard.module.scss'

function DripTriggerCard({ audienceName, audienceSize }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardContent}>
        <div className={styles.iconWrapper}>
          <WaveIcon />
        </div>
        <div className={styles.title}>Campaign starts</div>
        <div className={styles.subtitle}>
          {audienceName ? `Audience: ${audienceName}` : 'Select an audience in Preferences'}
        </div>
      </div>
      <div className={styles.audiencePanel}>
        <span className={styles.audienceCount}>
          {audienceSize ? formatNumberAsThousands(audienceSize) : '—'}
        </span>
        <span className={styles.audienceLabel}>guests targeted</span>
      </div>
    </div>
  )
}

export default DripTriggerCard
